import module from './module.js'
// Components
import './components/clientes/component.js'
import './components/component.js'
import './components/conceptos/component.js'
import './components/launcher/component.js'
import './components/lista/component.js'
// Services
import './services/Reportenominasmovimientos.js'
import './services/ReportenominasmovimientosConceptos.js'
import './services/ReportenominasmovimientosEmpresas.js'
import './services/ReportenominasmovimientosEmpresasClientes.js'
import './services/ReportenominasmovimientosEstados.js'
import './services/ReportenominasmovimientosExcel.js'
// Routes
import './routes/contabilidad-reportenominasmovimientos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/index.js